exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".FullScreenOverlay__wrapper--2Jzk5_0{position:absolute;top:0;left:0;right:0;bottom:0;background-color:rgba(0,0,0,.5);z-index:750;opacity:0;pointer-events:none}", "", {"version":3,"sources":["/Users/tylerjohnson/Sites/Buntin/ServProPrep/src/components/FullScreenOverlay.vue"],"names":[],"mappings":"AACA,qCAAS,kBAAkB,MAAM,OAAO,QAAQ,SAAS,gCAAiC,YAAY,UAAU,mBAAmB,CAClI","file":"FullScreenOverlay.vue","sourcesContent":["\n.wrapper{position:absolute;top:0;left:0;right:0;bottom:0;background-color:rgba(0,0,0,0.5);z-index:750;opacity:0;pointer-events:none\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"wrapper": "FullScreenOverlay__wrapper--2Jzk5_0"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true,"localIdentName":"[name]__[local]--[hash:base64:5]_0","importLoaders":true,"camelCase":true,"modules":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0ad7d9f4","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/FullScreenOverlay.vue
// module id = n9EL
// module chunks = 1